import { Box, Container, Typography, useTheme } from "@mui/material";
import { CardList } from "../card-list.js";
import { ProductContext } from "../provider.js";
import { SuspectName } from "./suspect-name.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";
export const CardsLayout = () => {
    const { t } = useTranslation("c-product");
    const { suspects } = React.useContext(ProductContext);
    const backgroundColor = "#F0EEEC";
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.only("sm"));
    return (React.createElement(Box, { component: "section", id: t("anchor-suspects", "der-kreis-der-verdaechtigen"), sx: {
            backgroundColor,
            boxShadow: "sectionBottom",
            pt: 8,
            pb: 6,
            position: "relative",
            zIndex: 10,
        } },
        React.createElement(Container, { maxWidth: "xl", sx: { pb: 6 } },
            React.createElement(Typography, { variant: "h2", sx: { pb: 0.5, hyphens: "none" } }, t("suspects-headline", "Die Verdächtigen")),
            React.createElement(Typography, { variant: "body1" }, t("suspects-copy-1", "Schlüpfe mit deinen Freunde für einen Abend in diese Rollen."))),
        React.createElement(CardList, { backgroundColor: backgroundColor, containerStyles: { pb: 3 } }, suspects.map(({ age, description, imageWithBorder, name }) => (React.createElement(Box, { className: "container", component: "li", key: `suspect-card-${name}` },
            React.createElement(Box, { sx: {
                    height: "auto",
                    mb: { xs: -7, sm: -6 },
                    mt: -4,
                    pb: { xs: 2, md: 3 },
                    pt: 0.5,
                    px: { xs: 0, sm: 0 },
                    transform: { xs: "scale(1.21)", sm: "scale(1.25)" },
                    transformStyle: "flat",
                    width: "100%",
                } },
                React.createElement(Image, { ...imageWithBorder, alt: `${name} (${age})`, placeholder: "empty", style: { width: "100%", height: "auto" } })),
            React.createElement(SuspectName, { age: age, name: name, sx: { mt: 3 } }),
            React.createElement(Typography, { className: "hyphenate", variant: isSm ? "body1" : "body1", sx: { pt: 0.5 } }, description)))))));
};
//# sourceMappingURL=cards-layout.js.map